<template>
  <div class="member-user">
    <div class="block-wrap content">
      <div class="flex-wrap">
      	<div class="menu-wrap">
					<div class="menu-item"
              v-for="(item, index) in navList"
              :key="'nav'+index">
            <div class="menu-item-item" :class="item === activeMenu ? 'active' : ''" @click="navClick(item)">
              <div class="menu-icon">
                <img :src="item === activeMenu ? item.activeIcon : item.icon" alt="">
              </div>
              <span>{{item.name}}</span>
              <div class="extra-icon" :class="item.expand ? 'expand' : ''" v-if="item.children"></div>
            </div>
            <div class="menu-item-children" v-if="item.children" v-show="item.expand">
              <div v-for="(child, idx) in item.children"
                  :key="'nav_child'+index+idx"
                  v-show="!child.permission || child.permission(user)"
                  :class="child.uri === activeUri ? 'active' : ''"
                  @click="linkTo(child.uri)">{{child.name}}</div>
            </div>
					</div>
      	</div>
        <Component :is="componentName" :c-id="cId" />
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import { navList } from './service/user';
import Overview from './Overview.vue';
import { mapState } from 'vuex';
const allComponentNames = ['Overview', 'BaseInfo', 'PersonalCertificate', 'OrgCertificate', 'Activity', 'Report', 'ProjectSetting', 'Notify', 'Award', 'Invoice']

const componentPermissions = {
  PersonalCertificate: (user) => user && user.memType === 'personal',
  OrgCertificate: (user) => user && user.memType === 'org',
  ProjectSetting: (user) => user && user.memType === 'org',
};

export default {
  data() {
    return {
      componentName: 'Overview',
      activeUri: '',
      activeMenu: null,
			cId: null,
      navList: navList.map(item => {
        item.expand = true;
        return item;
      })
    }
  },
  computed: {
    ...mapState(['user']),
  },
  components: {
    Overview,
    BaseInfo: () => import('./BaseInfo.vue'),
    PersonalCertificate: () => import('./PersonalCertificate.vue'),
    OrgCertificate: () => import('./OrgCertificate.vue'),
    ProjectSetting: () => import('./ProjectSetting.vue'),
    Activity: () => import('./Activity.vue'),
    Report: () => import('./Report.vue'),
    Notify: () => import('./Notify.vue'),
    Award: () => import('./Award.vue'),
    Invoice: () => import('./Invoice.vue'),
  },
  mounted() {
    this.renderComp();
  },
  methods: {
    navClick(item) {
      if (item.children && item.children.length) {
        this.$set(item, 'expand', !item.expand);
      } else {
        this.activeUri = item.uri;
        this.activeMenu = this.navList.find(n => n.uri === item.uri || (n.children && n.children.find(nc => nc.uri === item.uri)));
        this.linkTo(item.uri);
      }
    },
    canAccessComponent(componentName) {
      const checker = componentPermissions[componentName];
      if (!checker) {
        return true;
      }
      return checker(this.user);
    },
    renderComp() {
      const componentName = router.currentRoute.query.c;
			const cId = router.currentRoute.query.t;
      if (!componentName || allComponentNames.indexOf(componentName) === -1 || !this.canAccessComponent(componentName)) {
        const shouldRedirect = componentName
          && allComponentNames.indexOf(componentName) !== -1
          && !this.canAccessComponent(componentName);
        this.componentName = 'Overview';
        this.activeUri = '';
        this.activeMenu = this.navList[0];
        if (shouldRedirect && router.currentRoute.query.c) {
          router.replace('/system/user');
        }
      } else {
        this.componentName = componentName;
				this.cId = cId;
        this.activeUri = `?${router.currentRoute.fullPath.split('?')[1]}`;
        this.activeMenu = this.navList.find(n => n.uri === this.activeUri || (n.children && n.children.find(nc => nc.uri === this.activeUri)));
      }
    },
    linkTo(uri = '') {
      router.push(`/system/user${uri}`);
    }
  },
  watch: {
    $route(v) {
      if (v.name === 'SystemUser') {
        this.renderComp();
      }
    },
    user() {
      this.renderComp();
    },
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.member-user {
  background: url(../../assets/images/member-user-bg.png) repeat 0 330px;
  background-size: 100% 1119px;
  padding-bottom: 85px;
}
.content {
  background: url('http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/active-detail-bg.jpg') no-repeat center 0;
  background-size: 100% 330px;
  padding-top: 30px;

  .flex-wrap {
    display: flex;

    .menu-wrap {
      width: 180px;
      margin-right: 12px;
      height: 100%;
      position: relative;

      .menu-item {
        width: 180px;

        &-item {
          height: 40px;
          background: #FFFFFF;
          border: 1px solid #EBECEC;
          border-top: none;
          padding: 0 10px 0 33px;
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #131415;

          &:hover, &.active {
            color: #06AE63;
          }

          .menu-icon {
            width: 16px;
            height: 16px;
            margin-right: 9px;

            > img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }

          .extra-icon {
            width: 16px;
            height: 16px;
            background: url(../../assets/images/icon-down.png) no-repeat center center;
            background-size: 100% 100%;
            margin-left: auto;

            &.expand {
              background-image: url(../../assets/images/icon-top.png);
            }
          }

          &.active {
            background: #F1F3F3;
          }
        }

        &-children {
          background: #FFFFFF;

          > div {
            cursor: pointer;
            text-align: center;
            height: 40px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #131415;
            line-height: 40px;

            &:hover {
              background: rgba(6,174,99,0.1000);
              color: #06AE63;
            }

            &.active {
              color: #06AE63;
            }
          }
        }
      }
    }

    .content-wrap {
      flex: 1;
    }
  }
}
</style>
